import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OverviewDialogComponent } from './overview-dialog/overview-dialog.component';
import { InvoicerListadoDocsComponent } from './listadoDocs/listadoDocs.component';
import { SharedPipesModule } from 'src/app/shared/pipes/shared-pipes.module';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { InvoicerReactivoComponent } from './invoicer-reactivo/invoicer-reactivo.component';

@NgModule({
  declarations: [
    OverviewDialogComponent,
    InvoicerListadoDocsComponent,
    InvoicerReactivoComponent
  ],
  exports: [
    OverviewDialogComponent,
    InvoicerListadoDocsComponent,
    InvoicerReactivoComponent
  ],
  entryComponents: [
    OverviewDialogComponent
  ],
  imports: [
    CommonModule,
    SharedPipesModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule
  ]
})
export class InvoiceModule { }
